const themeActionsPrefix = "theme";

export const THEME_ACTIONS = {
  SET_THEME: `${themeActionsPrefix}/set-theme`,
  SET_SKIN: `${themeActionsPrefix}/set-skin`,
};
